const orders = {
    title: 'I tuoi ordini',
    errorLoading: 'Errore nel caricamento degli ordini',
    noOrders: 'Nessun ordine trovato',
    noOrdersMessage: 'Non hai ancora effettuato ordini di prodotti',
    orderId: 'ID Ordine',
    orderedOn: 'Ordinato il',
    quantity: 'Quantità',
    each: 'ciascuno',
    total: 'Totale',
    orderTimeline: 'Cronologia ordine',
    paidOn: 'Pagato il',
    shippedOn: 'Spedito il',
    deliveredOn: 'Consegnato il',
    cancelledOn: 'Annullato il',
    statusPending: 'In attesa',
    statusPaid: 'Pagato',
    statusShipped: 'Spedito',
    statusDelivered: 'Consegnato',
    statusCancelled: 'Annullato'
};

export default orders;
